'use client';

import { LinkButton } from '@/components/ui/Button/LinkButton';
import { useTranslations } from 'next-intl';
import Image from 'next/image';

import styles from './BookAppointmentModal.module.scss';
import type { SelectedBoutique } from './types';

export interface AppointmentSuccessStepProps {
  boutique: SelectedBoutique;
  fullName: string;
  /** Page layout renders the hero outside the success step. */
  hideHero?: boolean;
  onClose: () => void;
}

/**
 * Confirmation step after a successful appointment submission.
 */
export function AppointmentSuccessStep({
  boutique,
  fullName,
  hideHero = false,
  onClose,
}: Readonly<AppointmentSuccessStepProps>) {
  const t = useTranslations('appointment.success');

  return (
    <div className={styles.wrapper}>
      {hideHero ? null : (
        <div className={styles.successHero}>
          {boutique.imageUrl && (
            <Image
              src={boutique.imageUrl}
              alt=""
              fill
              className={styles.successImage}
              sizes="(max-width: 768px) 100vw, 750px"
            />
          )}
          <div className={styles.successHeroOverlay}>
            <h3 className={styles.successBoutiqueName}>{boutique.name}</h3>
          </div>
        </div>
      )}

      <div className={styles.successContent}>
        <p className={styles.successGreeting}>{fullName}</p>
        <p className={styles.description}>{t('message')}</p>
        <LinkButton href="/watches/all" variant="primary" size="md" fullWidth onClick={onClose}>
          {t('discoverCollections')}
        </LinkButton>
      </div>
    </div>
  );
}

AppointmentSuccessStep.displayName = 'AppointmentSuccessStep';
